import { BeneficiaryEntityType } from "@common/utils/graphql";
import { z } from "zod";

export const beneficiaryAddressValidator = z.object({
  streetAddress: z.string(),
  city: z.string(),
  state: z.string(),
  countryCode: z.string(),
  postcode: z.string(),
});

export const additionalInfoValidator = z
  .object({
    personalEmail: z.string().email().nullish(),
  })
  .passthrough();

export const bankDetailsValidator = z
  .object({
    accountCurrency: z.string(),
    accountName: z.string(),
    accountNumber: z.string().optional(),
    accountRoutingType1: z.string(),
    accountRoutingValue1: z.string(),
    bankCountryCode: z.string().length(2),
    bankAccountCategory: z.string().nullish(),
    localClearingSystem: z.string().nullish(),
  })
  .passthrough();

export const beneficiaryDetailsValidator = z.object({
  additionalInfo: additionalInfoValidator
    .nullish()
    .transform((val) => (val ? JSON.stringify(val) : undefined)),
  address: beneficiaryAddressValidator,
  bankDetails: bankDetailsValidator.transform((val) => JSON.stringify(val)),
  dateOfBirth: z.string().nullish(),
  entityType: z.nativeEnum(BeneficiaryEntityType),
  firstName: z.string(),
  lastName: z.string(),
});

export const beneficiaryValidator = z.object({
  beneficiary: beneficiaryDetailsValidator,
  nickname: z.string().nullish(),
  paymentMethods: z.array(z.string()).default(["LOCAL"]),
});
